module.exports = __webpack_public_path__ + "static/img/logo.fb448635.png";